<div class="notifications-container">
  <h2>Email Scheduler</h2>
  <div class="instruction">Schedule day and time to send out automated emails to your team.</div>
  <form [formGroup]="notificationsForm">
    <table class="table">
      <thead>
        <tr>
          <th class="border-0"></th>
          <th class="border-0"></th>
          <th colspan="2" class="border-0 py-0">
            <div class="pb-1 border-bottom">Schedule</div>
          </th>
          <th colspan="2" class="border-0 py-0">
            <div class="pb-1 border-bottom">Submission deadline</div>
          </th>
          <th colspan="3" class="border-0"></th>
        </tr>
        <tr>
          <th>Nickname</th>
          <th>Subject</th>
          <th>Day</th>
          <th>Time</th>
          <th>Day</th>
          <th>Time</th>
          <th></th>
          <th colspan="3" class="pl">Actions</th>
        </tr>
      </thead>
      <tbody>
        @if (rowsArr.controls.length === 0) {
          <tr>
            <td colspan="9">There are no emails scheduled</td>
          </tr>
        }
        <ng-container formArrayName="rows">
          @for (rowItem of rowsArr.controls; track rowItem; let i = $index) {
            <tr [formGroupName]="i">
              <td><input type="text" formControlName="nickname" class="form-control"
                title="{{notifications[i] ? notifications[i].nickName : ''}}" required>
                @if (rowsArr.at(i).get('nickname')?.errors && rowsArr.at(i).get('nickname')?.touched) {
                  <div class="text-danger mt-1"
                    >
                  This field is required</div>
                }
              </td>
              <td>
                {{ (notifications$ | async)![i] ? (notifications$ | async)![i].subject : 'Reminder to submit
                your timesheet' }}
                <input type="hidden" formControlName="notificationId">
              </td>
              <td class="dow">
                <ng-select formControlName="dayOfWeek" placeholder="Select one" [searchable]="false"
                  bindValue="value" bindLabel="name" [items]="dow" [clearable]="false"
                  title="day of the week" dropdownPosition="bottom">
                </ng-select>
              </td>
              <td class="tod">
                <ngb-timepicker [meridian]="true" [spinners]="false" formControlName="timeOfDay"
                required></ngb-timepicker>
                @if (rowsArr.at(i).get('timeOfDay')?.errors && rowsArr.at(i).get('timeOfDay')?.touched) {
                  <div class="text-danger mt-1"
                    >
                  This field is required</div>
                }
              </td>
              <td class="dow">
                <ng-select formControlName="deadlineDayOfWeek" placeholder="Select one" [searchable]="false"
                  bindValue="value" bindLabel="name" [items]="dow" [clearable]="false"
                  title="day of the week" dropdownPosition="bottom">
                </ng-select>
              </td>
              <td class="tod">
                <ngb-timepicker [meridian]="true" [spinners]="false" formControlName="deadlineTimeOfDay"
                required></ngb-timepicker>
                @if (rowsArr.at(i).get('deadlineTimeOfDay')?.errors && rowsArr.at(i).get('deadlineTimeOfDay')?.touched) {
                  <div class="text-danger mt-1"
                    >
                  This field is required</div>
                }
              </td>
              <td class="actions">
                <div class="toggleSwitch">
                  <label class="form-switch">
                    <input type="checkbox" formContorlName="isActive"
                      [checked]="(notifications$ | async)![i] ? (notifications$ | async)![i].active : true"
                      (change)="updateActive(i, $event.target)">
                    <i
                    title="{{ (notifications$ | async)![i] ? ((notifications$ | async)![i].active === true ? 'Active' : 'Inactive') : true}}"></i>
                  </label>
                </div>
              </td>
              <td class="actions">
                <button class="btn btn-link" (click)="previewEmail(i, preview);" type="button"
                title="Preview">Preview</button>
              </td>
              <td class="actions edit">@if (editRowIdx !== i) {
                <button class="btn btn-link" (click)="editRow(i);" type="button"
                  title="Edit" [attr.disabled]="setBtnsDisabled(i)">Edit
                {{setBtnsDisabled(i)}}</button>
              }
              @if (editRowIdx === i) {
                <button class="btn btn-link" (click)="saveRow(i);" type="button" title="Save"
                [attr.disabled]="validate(i)">Save</button>
              }
              @if (editRowIdx === i) {
                <button class="btn btn-link" (click)="cancelRow(i);" type="button" title="Cancel"
                >Cancel</button>
              }
            </td>
          </tr>
        }
      </ng-container>

    </tbody>
  </table>
  <button type="button" class="btn btn-link d-flex btn-add" (click)="addNotification()"><i
  class="fa-solid fa-circle-plus fa-2x"></i>
  <div class="mx-2">Add an email</div>
</button>
</form>
</div>


<ng-template #preview let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Email Preview</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <table width="100%" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td align="center">
          <table class="emailContainer" cellpadding="40" cellspacing="0">
            <tr>
              <td style="background-color: #ffffff;border: solid 1px #dedede; height: 350px;"
                valign="top">
                <div class="emailContent">
                  <div class="dnvLogo"><img src="/assets/images/dnv-logo.png" width="200">
                  </div>
                  <div [innerHTML]="previewContent"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="footer-td">
                <div class="footer">
                  <p>Please do not reply to this email &#8212; this mailbox is not monitored.</p>
                  <p>District of North Vancouver</p>
                  <p>355 W Queens Road, North Vancouver, BC, V7N 4N5</p>
                  <p>604-990-2311</p>
                  <p><a href="mailto:inquires@dnv.org" style="color: #1890ff;">inquires&#64;dnv.org</a>
                </p>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>
</ng-template>